import { Alert, Box, Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { useResource } from 'hooks/useResource';
import { useParams } from 'react-router-dom';
import { useAgendaContext } from '../contexts/AgendaContext';
import FormNoteTopic from '../forms/FormNoteTopic';

export default function ModalNoteTopic() {
  const { id } = useParams() as { id: string };
  const { data: note } = useResource({ id, resourceName: 'note', path: 'notes' });
  const { modals, topic } = useAgendaContext();

  return (
    <Modal 
      variant="form"
      isOpen={modals.noteTopic.isOpen} 
      onClose={modals.noteTopic.onClose}
    >
      <ModalOverlay />
      <ModalContent overflow="visible">
        <ModalHeader>
        { topic ? 'Editar tópico' : 'Novo tópico' }
          
          <span>{ topic ? 'Editando tópico da nota:' : 'Você está criando um novo tópico para a nota:' }</span>
        </ModalHeader>
        <ModalCloseButton />

        <Box mt="20px" px="20px">
          <Alert status="success" variant="left-accent">
            { note && <Text noOfLines={1}>{note?.title}</Text> }
          </Alert>
        </Box>

        <Divider mt="20px" mb="10px" />
        <ModalBody overflow="visible">
          <FormNoteTopic topic={topic} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}